export const Errors_EN = {
  // Toasts used for challenges
  error: {
    page: {
      doesntExist: "This page does not exist",
    },
    action: {
      backToHome: "Back to home",
    },
  },
};
